import { CardTrioInputs } from './CardTrio';
import { CardTrioCard } from './CardTrioCard';

export const cewCardTrioHelper = (node): CardTrioInputs => {
    const videoChannelLinkStr = node.field_video_channel_link ?? undefined;

    const card1: CardTrioCard = {
        id: `${node.id}-1`,
        image: node.relationships?.field_card_image?.localFile?.childImageSharp
            .gatsbyImageData,
        imageAlt: node.field_card_image?.alt,
        title: node.field_card_title,
        description: node.field_card_description,
        linkUrl: node.field_card_link_url,
        linkText: node.field_card_link_title,
    };
    const card2: CardTrioCard = {
        id: `${node.id}-2`,
        image: node.relationships?.field_card_image_2?.localFile
            ?.childImageSharp.gatsbyImageData,
        imageAlt: node.field_card_image_2?.alt,
        title: node.field_card_title_2,
        description: node.field_card_description_2,
        linkUrl: node.field_card_link_url_2,
        linkText: node.field_card_link_title_2,
    };
    const card3: CardTrioCard = {
        id: `${node.id}-3`,
        image: node.relationships?.field_card_image_3?.localFile
            ?.childImageSharp.gatsbyImageData,
        imageAlt: node.field_card_image_3?.alt,
        title: node.field_card_title_3,
        description: node.field_card_description_3,
        linkUrl: node.field_card_link_url_3,
        linkText: node.field_card_link_title_3,
    };
    return {
        id: node.id,
        header: node.field_card_trio_header,
        cards: [card1, card2, card3],
        videoChannelLink: videoChannelLinkStr,
    };
};
